import React from 'react';
import { cn } from '@/lib/utils';

export const GlassCard = React.forwardRef(({ className, children, hover = false, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-[0_18px_60px_rgba(0,0,0,0.55)]',
      hover && 'transition-colors duration-200 hover:border-white/15 hover:bg-white/[0.07]',
      className
    )}
    {...props}
  >
    {children}
  </div>
));
GlassCard.displayName = 'GlassCard';
